import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Snackbar from "@material-ui/core/Snackbar";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { AddCity, EditCity, GetCity, GetProvinces } from "../../fetchs";
import MenuItem from "@material-ui/core/MenuItem";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const useStyles = (theme) => ({
  appBar: {
    position: "relative",
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  labelAsterisk: {
    color: "red",
  },
  cssLabel: {
    color: "orange",
  },
  cssRequired: {
    "&:before": {
      borderBottom: "2px solid orange",
    },
  },
});

class Brand extends Component {
  constructor(props) {
    super(props);

    this.state = {
      province: [],
      cityId: null,
      name: "",
      nameHelper: "",

      loading: false,
      saving: false,
      openSnackbar: false,
      errorMessage: "",
      provinceId: null,
    };
  }

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };

  componentDidMount() {
    GetProvinces(0, 9999)
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ province: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });
    const cityId = this.props.match.params.cityId;
    if (cityId) {
      this.loadCity(cityId);
    }
  }

  loadCity = (cityId) => {
    this.setState({ loading: true });
    GetCity(cityId)
      .then((response) => {
        this.setState({ loading: false });
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else
          this.setState({
            cityId: responseJson.id,
            name: responseJson.name,
            provinceId: responseJson.provinceId,
          });
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.log(error);
      });
  };

  handleSave = () => {
    if (this.props.match.params.cityId) this.editCity();
    else this.addCity();
  };

  addCity = () => {
    AddCity({
      name: this.state.name,
      provinceId: this.state.provinceId,
    })
      .then((response) => {
        if (response.status !== 200) {
          toast.error("خطای اضافه شدن شهر");
        } else if (response.status === 200) {
          toast.success(" شهر با موفقیت اضافه شد");
          this.props.history.push("/main/cities");
        }
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  editCity = () => {
    EditCity({
      id: this.props.match.params.cityId,
      name: this.state.name,
      ProvinceId: this.state.provinceId,
    })
      .then((response) => {
        if (response.status !== 200) {
          toast.error("خطای ویرایش شدن شهر");
        } else if (response.status === 200) {
          toast.success(" شهر با موفقیت ویرایش شد");
          this.props.history.push("/main/cities");
        }
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };
  onchange = (event) => {
    let valid;

    switch (event.target.id) {
      case "name":
        this.setState({ name: event.target.value });
        valid = event.target.value.length > 0;
        if (!valid) {
          this.setState({ nameHelper: "لطفا نام شهر را وارد کنید" });
        } else {
          this.setState({ nameHelper: "" });
        }
        break;

      default:
        break;
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            {this.props.match.params.cityId ? (
              <Typography component='h1' variant='h4' align='center'>
                ویرایش شهر
              </Typography>
            ) : (
              <Typography component='h1' variant='h4' align='center'>
                افزودن شهر جدید
              </Typography>
            )}
            <React.Fragment>
              <form className={classes.container} noValidate autoComplete='off'>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      InputLabelProps={
                        this.state.provinceId === null
                          ? {
                              classes: {
                                root: classes.cssLabel,
                              },
                              FormLabelClasses: {
                                asterisk: classes.labelAsterisk,
                              },
                            }
                          : ""
                      }
                      InputProps={
                        this.state.provinceId === null
                          ? {
                              classes: {
                                underline: classes.cssRequired,
                              },
                            }
                          : ""
                      }
                      id='standard-select-city'
                      select
                      label='استان'
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.provinceId}
                      onChange={this.handleChange("provinceId")}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin='normal'
                    >
                      {this.state.province.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name} - {option.province}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      error={this.state.nameHelper.length !== 0}
                      helperText={this.state.nameHelper}
                      onChange={this.onchange}
                      id='name'
                      label='شهر'
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.name}
                      margin='normal'
                      InputLabelProps={
                        this.state.name.length === 0
                          ? {
                              classes: {
                                root: classes.cssLabel,
                              },
                              FormLabelClasses: {
                                asterisk: classes.labelAsterisk,
                              },
                            }
                          : ""
                      }
                      InputProps={
                        this.state.name.length === 0
                          ? {
                              classes: {
                                underline: classes.cssRequired,
                              },
                            }
                          : ""
                      }
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Button
                      variant='contained'
                      color='primary'
                      fullWidth
                      disabled={
                        this.state.loading ||
                        this.state.nameHelper.length !== 0 ||
                        this.state.name.length === 0 ||
                        this.state.provinceId === null
                      }
                      onClick={this.handleSave}
                    >
                      ذخیره
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </React.Fragment>
          </Paper>
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            autoHideDuration={3000}
            open={this.state.openSnackbar}
            ContentProps={{
              "aria-describedby": "message-id",
              class:
                "error MuiTypography-root MuiPaper-root MuiPaper-elevation6 MuiSnackbarContent-root MuiTypography-body2",
            }}
            message={<span id='message-id'> {this.state.errorMessage} </span>}
            onClose={() => this.handleCloseSnackbar(false)}
          />
        </main>
      </React.Fragment>
    );
  }
}

Brand.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(useStyles)(Brand));
